/**
 * Payments API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { Payment, PaymentFilters } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const paymentsApi = {
  process: async (paymentData: Partial<Payment>) => {
    const context = getContext();
    return router.post<Payment>('/accounting/payments/process', paymentData, context);
  },
  recordManual: async (body: {
    tenantId: string;
    allocations: { receivableId: string; amount: number }[];
    bankAccountId: string;
    method: 'Check' | 'Cash' | 'Money Order';
    referenceNumber: string;
    paymentDate?: string;
    idempotencyKey?: string;
  }) => {
    const context = getContext();
    return router.post<Payment>('/accounting/payments', body, context);
  },
  list: async (filters?: PaymentFilters) => {
    const query = filters ? '?' + new URLSearchParams(filters as Record<string, string>).toString() : '';
    return router.get<Payment[]>(`/payments${query}`);
  },
  get: async (id: string) => router.get<Payment>(`/payments/${id}`),
};

